/* 销售渠道 API */

import { httpPost } from '../assets/scripts/http';

/**
 * 获取销售管道
 * @param { CompanyName,PageIndex,pageSize} data
 */
export function getOpenShareList(data) {
  return httpPost('shareStock/getMyOpenShareListAsync', data);
}

/**
 * 屏蔽/取消屏蔽管道
 * @param {IsOpen,RequestIds} data
 */
export function setShareRequestStatus(data) {
  return httpPost('shareStock/setShareRequestStatusAsync', data);
}

/**
 * 获取类别
 */
export function getShareDiscountList() {
  return httpPost('shareStock/PostShareDiscountListAsync');
}

/**
 * 设置类别
 * @param {RequestIds,Grade} data
 */
export function setShareCompanysGrade(data) {
  return httpPost('shareStock/PostSetShareCompanysGradeAsync', data);
}
